/*
 * Heavy users get lumped into one overflow bucket so a single power user cannot
 * stretch the x axis into unreadability.
 */
export const MAX_SESSION_BUCKET = 30;

export interface SessionBucket {
  label: string;
  users: number;
}

/** Users per session count, one bar each, with everything past 30 in "30+". */
export function bucketSessions(
  distribution: { sessions: number; users: number }[],
): SessionBucket[] {
  if (distribution.length === 0) return [];

  const max = Math.min(
    MAX_SESSION_BUCKET,
    Math.max(...distribution.map((one) => one.sessions)),
  );
  const users = Array.from({ length: max }, () => 0);
  for (const one of distribution) {
    users[Math.min(one.sessions, MAX_SESSION_BUCKET) - 1] += one.users;
  }

  return users.map((count, index) => ({
    label:
      index === MAX_SESSION_BUCKET - 1 ? `${MAX_SESSION_BUCKET}+` : String(index + 1),
    users: count,
  }));
}
